<!-- EDIT CAMPAIGN MODAL START-->
<script>
// import { mapActions } from 'vuex'
// import  * as services  from '../services' 
export default {
    data() {
        return {
            froala_config: {
                'fullPage': true,
                'iframe': true,
                'height': 300,
                'toolbarButtons': ['fullscreen', 'bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript', '|', 'fontFamily', 'fontSize', 'color', 'inlineStyle', 'paragraphStyle', '|', 'paragraphFormat', 'align', 'formatOL', 'formatUL', 'outdent', 'indent', 'quote', '-', 'insertLink', 'insertImage', 'insertVideo', 'insertFile', 'insertTable', '|', 'emoticons', 'specialCharacters', 'insertHR', 'selectAll', 'clearFormatting', '|', 'print', 'spellChecker', 'help', 'html', '|', 'undo', 'redo', 'tags_selector']
            },
            liveCampaigns: [],
            domain_name: '',
            domains: [],
            domainsList: [],
            recp: false,
            data: {},
            campaignData: {}
        }
    },
    props: ['campaign', 'id', 'scenario'],

    watch: {

    },
    beforeMount() {
        this.$http.get('/companies/domains').then((response) => {
            this.domainsList = response.data.data;
            let domains = this.domainsList.map((domain) => {
                let obj = {
                    label: domain.name,
                    value: domain.id
                }
                return obj;
            });
            this.domains = domains;
        })

        this.data.emailTemplate = this.scenario.email_template;
        this.data.landingTemplate = this.scenario.landing_template;
        this.data.educationTemplate = this.scenario.scenario.education;

        this.campaignData = this.scenario;
    },
    mounted() {


    },
    methods: {
        editCampaignSchedule() {
            this.$validator.validateAll().then(success => {
                if (success) {
                    let data =
                        {
                            send_after: this.campaignData.sendAfter,
                            send_after_type: this.campaignData.sendAfterType,
                            id: this.campaignData.id,
                            from_name: this.campaignData.from_name,
                            from_sender: this.campaignData.from_sender,
                            from_domain_id: this.campaignData.from_domain_id,
                            from_domain_type: this.campaignData.from_domain_type,
                            landing_sub_domain: this.campaignData.landing_sub_domain,
                            landing_domain_id: this.campaignData.landing_domain_id,
                            landing_sub_path: this.campaignData.landing_sub_path,
                            subject: this.campaignData.subject,
                            send_at: this.campaignData.send_at
                        };
                    this.$http.post('/bulk/campaign/schedulecampaign/edit', data).then((response) => {
                        $('#editCampaign_'+this.campaignData.id).modal('hide');
                    });

                    let ELTdata = {
                        id: this.campaignData.id,
                        email_template: this.data.emailTemplate.file,
                        landing_template: this.data.landingTemplate.file
                    };
                    this.$http.post('/bulk/campaign/schedule/'+this.campaignData.id, ELTdata).then((response) => {
                        $('#editCampaign_'+this.campaignData.id).modal('hide');
                        this.$parent.$emit('showUpdateSuccessFullMesssage');
                    });
                }
            });

        },
        // changeScenario(id)
        // {   
        //     this.$parent.campaign_id = id;
        //     this.$parent.isChangeCampapaignScenario = true;
        //     $('#myModal').modal('show');
        //     this.$parent.getScenarioDetail();
        // }
        click_recp: function() {
            this.recp = this.recp ? 0 : 1;
        },
        place_holder: function(val) {
            if (this.data.subject.substr(-1) == " ") {
                this.data.subject += val + " ";
            } else {
                this.data.subject += " " + val + " ";
            }
        }

    }
}
</script>

<template>
    <div class="modal fade stick-up" :id="'editCampaign_'+id" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog modal-lg" style="width:80%;">
            <div class="modal-content">

                <div class="modal-header clearfix text-left" style='width: 100%;'>
                    <button type="button" class="close" data-dismiss="modal" aria-hidden="true">
                        <i class="pg-close fs-14"></i>
                    </button>
                    <h5 class="font-montserrat text-complete">{{campaignData.scenario.name}}
                        <i class="fa fa-chevron-right"></i>
                    </h5>
                    <p class="hint-text m-t-10 small">{{campaignData.scenario.description}}</p>
                </div>

                <div class="modal-body">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="row">
                                <div class="col-md-12 no-padding">
                                    <div class="alert alert-info visible-xs m-r-5 m-l-5" role="alert">
                                        <button class="close" data-dismiss="alert"></button>
                                        <strong>Info: </strong> On mobile the tab will be come a Accorian by using data-init-reponsive-tabs="collapse"
                                    </div>
                                    <div class="panel p-t-30 p-b-30">
                                        <div class="panel-body no-padding">
                                            <div class="row">
                                                <div class="col-md-12" v-if='data.emailTemplate'>
                                                    <h4 class="font-montserrat">Email body
                                                    </h4>
                                                    <hr>
                                                    <!-- <p v-if='campaign.locked == 1' v-html="data.emailTemplate.file" ></p> -->
                                                    <froala :tag="'textarea'" :config="froala_config" v-model="data.emailTemplate.file"></froala>
                                                </div>
                                                <div class="col-md-12">
                                                    <h4 class="font-montserrat">Landing page preview
                                                    </h4>
                                                    <hr>
                                                    <!-- <p v-if='campaign.locked == 1' v-html="data.landingTemplate.file" ></p> -->
                                                    <froala  :tag="'textarea'" :config="froala_config" v-model="data.landingTemplate.file"></froala>
                                                </div>

                                                <div class="col-md-12 m-t-40" v-if='data.educationTemplate'>
                                                    <div class="row">
                                                        <div class="col-lg-6">
                                                            <h4 class="font-montserrat " style="font-size: 26px; font-weight: bold; text-transform: uppercase;">Education Preview</h4>
                                                        </div>
                                                    </div>

                                                    <div class="panel panel-default scen">
                                                        <div class="panel-heading">

                                                            <h5 class="bold">{{ data.educationTemplate.name }}</h5>

                                                        </div>
                                                        <div class="panel-body">
                                                            <div class=" p-b-5">
                                                                <img v-bind:src="data.educationTemplate.link" class="img-responsive" />
                                                            </div>
                                                            <p class="scenarios_description">{{ data.educationTemplate.description }}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-md-12">
                                                    <h4 class="font-montserrat">Sending Details
                                                    </h4>
                                                    <form class="" role="form">
                                                        <div class="row">
                                                            <div class="col-sm-6">
                                                                <div class="form-group form-group-default">
                                                                    <label>{{ $t("campaign.email.sender_name") }}</label>
                                                                    <input type="text" name='from_name' v-validate="'required|alpha_spaces'" v-model='campaignData.from_name' class="form-control" placeholder="A make believe from full name.. e.g. John Smith">

                                                                    <span v-show="errors.has('from_name')" class="help is-danger">
                                                                        {{ errors.first('from_name') }}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="row">
                                                            <div class="col-sm-6">
                                                                <div class="form-group form-group-default">
                                                                    <label>{{ $t("campaign.email.email_subject") }}</label>
                                                                    <input type="text" name='subject' v-validate="'required'" v-model='campaignData.subject' class="form-control" placeholder="A make believe from name..">
                                                                    <span v-show="errors.has('subject')" class="help is-danger">
                                                                        {{ errors.first('subject') }}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            <div class="col-sm-6">
                                                                <div class="row">
                                                                    <div class="col-sm-6 col-md-6 col-lg-6 col-xs-6 no-padding">
                                                                        <div class="form-group form-group-default">
                                                                            <label>{{ $t("campaign.email.sender") }}</label>
                                                                            <input type="text" name='from_sender' v-validate="'required'" v-model='campaignData.from_sender' class="form-control" placeholder="A make believe from name..">
                                                                            <span v-show="errors.has('from_sender')" class="help is-danger">
                                                                                {{ errors.first('from_sender') }}
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-md-1 col-sm-1 col-xs-1 col-lg-1 no-padding">
                                                                        <p style="text-align: center;font-size: 20px;line-height: 54px;background: #ececec;">@</p>
                                                                    </div>
                                                                    <div class="col-sm-5 col-lg-5 col-xs-5 col-md-5 no-padding">
                                                                        <div class="form-group form-group-default">
                                                                            <label>Select Domain</label>
                                                                            <el-select v-model="campaignData.from_domain_id" class='form-control el-select-wrapper' placeholder="Select Domain">
                                                                                <el-option v-for="item in domains" :key="item.value" :label="item.label" :value="item.value">
                                                                                </el-option>
                                                                            </el-select>
                                                                            <span v-show="isDomainSelected" class="help is-danger">
                                                                                {{ $t("campaign.email.please_select_a_domain_name") }}
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                        </div>
                                                        <div class="row">
                                                            <div class="col-sm-6">
                                                                <div class="checkbox">
                                                                    <p>{{ $t("campaign.email.personalise_subject_email") }}
                                                                        <a v-on:click="click_recp()">{{ $t("campaign.email.click_here_to_see_complete_list") }}</a>
                                                                    </p>
                                                                    <div v-show="recp==1">
                                                                        <a value="{FIRST_NAME}" v-on:click="place_holder('{FIRST_NAME}')">{FIRST_NAME}</a>,
                                                                        <a value="{LAST_NAME}" v-on:click="place_holder('{LAST_NAME}')">{LAST_NAME}</a>,
                                                                        <a value="{EMAIL}" v-on:click="place_holder('{EMAIL}')">{EMAIL}</a>,
                                                                        <a value="{NUMBER}" v-on:click="place_holder('{NUMBER}')">{NUMBER}</a>,
                                                                        <a value="{DESIGNATION}" v-on:click="place_holder('{DESIGNATION}')">{DESIGNATION}</a>,
                                                                        <a value="{DEPARTMENT}" v-on:click="place_holder('{DEPARTMENT}')">{DEPARTMENT}</a>,
                                                                        <a value="{LOCATION}" v-on:click="place_holder('{LOCATION}')">{LOCATION}</a>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div class="row">
                                                            <div class="col-md-12">
                                                                <div class="padding-5 bg-master-lighter p-l-15 p-r-15">
                                                                    <h3 class="no-margin p-t-10 p-b-10">{{ $t("campaign.landing.specify_landing_url") }}</h3>

                                                                    <div class="col-sm-4 no-padding">
                                                                        <div class="form-group form-group-default">
                                                                            <label>{{ $t("campaign.landing.subdomain") }}</label>
                                                                            <input type="text" name='landing_sub_domain' autofocus v-validate="'required|alpha_num'" v-model='campaignData.landing_sub_domain' class="form-control" placeholder="A make believe subdomain name.." v-focus>
                                                                            <span v-show="errors.has('landing_sub_domain')" class="help is-danger">
                                                                                {{ errors.first('landing_sub_domain') }}
                                                                            </span>
                                                                        </div>
                                                                    </div>

                                                                    <div class="col-sm-4 no-padding">
                                                                        <div class="form-group form-group-default">
                                                                            <label>Select Domain</label>
                                                                            <el-select v-model="campaignData.landing_domain_id" class='form-control el-select-wrapper' clearable placeholder="Select Domain">
                                                                                <el-option v-for="item in domains" :key="item.value" :label="item.label" :value="item.value">
                                                                                </el-option>
                                                                            </el-select>
                                                                            <span v-show="isDomainSelected" class="help is-danger">
                                                                                {{ $t("campaign.landing.please_select_any_domain_name") }}
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-sm-4 no-padding">
                                                                        <div class="form-group form-group-default">
                                                                            <label>{{ $t("campaign.landing.subdirectory_file") }}</label>
                                                                            <input type="text" name='sub_directory' v-model='campaignData.landing_sub_path' class="form-control" placeholder="A make believe sub_directory name.." v-validate="'required|alpha_num'">
                                                                            <span v-show="errors.has('sub_directory')" class="help is-danger">
                                                                                {{ errors.first('sub_directory') }}
                                                                            </span>
                                                                        </div>

                                                                    </div>
                                                                    <br class="clearfix">
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </form>
                                                </div>
                                                <div class="col-md-12 b-t b-grey p-t-30 m-t-30">
                                                    <!-- <div class="pull-left">
                                                                            <button class="btn btn-complete btn-space" data-toggle="modal" data-target="#myModal">Letter Send a Test Email </button>
                                                                            <button class="btn btn-complete btn-space" data-target="#myModal2" data-toggle="modal">Email Summary</button>
                                                                        </div> -->
                                                    <div class="pull-right">
                                                        <button v-if='campaign.locked == 1' class="btn btn-complete btn-space" data-dismiss="modal" aria-hidden="true" type="button"> Close</button>
                                                        <button v-if='campaign.locked !== 1' class="btn btn-complete btn-space" type="button" @click="editCampaignSchedule"> Save</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// editCampaignModal.vue?037712dd